import React from "react"
import {QuickLinkBannerLinkProps} from "../.."
import {BannerLink} from "./components"

export const Chevron = (props: QuickLinkBannerLinkProps) => {
    const {href, title, children} = props

    return (
        <BannerLink href={href} title={title}>
            {children}
        </BannerLink>
    )
}

export default Chevron
